import { AMPLITUDE_API_KEY } from '#src/config.ts';
import { loadCookie } from '#src/lib/cookies.ts';
import { sendSafeError } from '#src/lib/error.ts';

import { loadSessionReplayModule } from './sessionReplayModule.ts';
import {
  SIGNUP_REPLAY_TRIGGER_EVENTS,
  sessionReplayState,
} from './sessionReplayState.ts';

const hasAmplitudeConsent = () => {
  const { destinations } = loadCookie('tracking-preferences2') ?? {};
  return Boolean(
    destinations?.Amplitude || destinations?.['Actions Amplitude']
  );
};

export const maybeStartSessionReplay = async (
  event: string,
  flagEnabled: boolean
): Promise<void> => {
  if (
    !SIGNUP_REPLAY_TRIGGER_EVENTS.has(event) ||
    sessionReplayState.active ||
    !flagEnabled ||
    !hasAmplitudeConsent() ||
    !window.analytics?.user
  ) {
    return;
  }
  const deviceId = window.analytics.user().anonymousId();
  const sessionId = Number(loadCookie('analytics_session_id')) || 0;
  // Set before the async load so a concurrent trigger event does not init twice.
  sessionReplayState.active = true;
  try {
    const sessionReplay = await loadSessionReplayModule();
    // Shutdown may have been requested while the chunk was downloading
    // (e.g. provider unmount): starting to record now would leave no way
    // to stop it.
    if (!sessionReplayState.active) {
      return;
    }
    sessionReplay.init(AMPLITUDE_API_KEY, {
      deviceId,
      sessionId,
      sampleRate: 1,
    });
  } catch (error) {
    // Chunk failed to load (e.g. network error): allow a later retry.
    sessionReplayState.active = false;
    sendSafeError(error);
  }
};
